export default "__VITE_ASSET__DhnOKYSc__"